import { render, staticRenderFns } from "./KurdishContract.vue?vue&type=template&id=027c7c04&scoped=true&"
import script from "./KurdishContract.vue?vue&type=script&lang=js&"
export * from "./KurdishContract.vue?vue&type=script&lang=js&"
import style0 from "./KurdishContract.vue?vue&type=style&index=0&id=027c7c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027c7c04",
  null
  
)

export default component.exports